import { useEffect, useState } from "react";

export function toast(msg) {
  window.dispatchEvent(new CustomEvent("legis-toast", { detail: msg }));
}

export function Toaster() {
  const [msg, setMsg] = useState(null);
  useEffect(() => {
    let timer;
    const handler = (e) => {
      setMsg(e.detail);
      clearTimeout(timer);
      timer = setTimeout(() => setMsg(null), 3500);
    };
    window.addEventListener("legis-toast", handler);
    return () => { window.removeEventListener("legis-toast", handler); clearTimeout(timer); };
  }, []);
  if (!msg) return null;
  return <div className="toast" data-testid="toast">{msg}</div>;
}
